/*@ngInject*/
const LoadActivityRepository = function (baseRepository, xmlUtil) {

    angular.extend(this, baseRepository);

    this.loadActivityStreamItems = function (activityParams) {
        let url = '/rest/ActivityEvent/filter',
            config = {
                params: {
                    filterUri: activityParams.filterUri,
                    startIndex: activityParams.startIndex,
                    numberOfRows: activityParams.pageSize
                }
            };

        return this.get(url, config);
    };

    this.processGetResponseData = function (responseData) {
        let records = _.map(responseData.records, function (item) {
            item.note = xmlUtil.parseString(item.note);
            item.triggerTime = new Date(item.triggerTime);
            return item;
        });
        return {
            totalRecords: responseData.totalRecords,
            records: records
        }
    };
};

angular.module('umLanding')
    .service('loadActivityRepository', LoadActivityRepository);
